function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "param(fill) #252525",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.382 10.66L.736 15.668h18.528l-6.646-5.006-1.59 1.31a1.616 1.616 0 01-2.056 0l-1.59-1.31zM20 4.575l-6.667 5.497L20 15.106zM0 4.575v10.53l6.667-5.033z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M.702 4l8.826 7.278c.22.181.724.181.944 0L19.3 4H.702z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.382 10.66L.736 15.668h18.528l-6.646-5.006-1.59 1.31a1.616 1.616 0 01-2.056 0l-1.59-1.31zM20 4.575l-6.667 5.497L20 15.106zM0 4.575v10.53l6.667-5.033z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M.702 4l8.826 7.278c.22.181.724.181.944 0L19.3 4H.702z"
}));

function SvgSend(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgSend;